import publishedAsKpiImage from '../../../assets/icon_data.svg';
import publishedAsCalulatedImage from '../../../assets/icon_datapoint_calculated.svg';
import './DpdTableIcon.scss';

type Props = {
	dpType: string;
};
export const DATAPOINT_TYPE_LABELS = [
	{
		value: 'CALCULATED',
		label: {
			id: 'general.dpType.calculated',
			defaultValue: 'Calculated Datapoint'
		}
	},
	{
		value: 'RAW',
		label: {
			id: 'general.publishedAs.kpi',
			defaultValue: 'KPI'
		}
	}
];
export const DpTypeIcon = ({dpType}: Props) => {
	if (dpType === 'RAW') {
		return <img src={publishedAsKpiImage} alt="dpTypeIcon" className="dpd-table-icon" />;
	} else if (dpType === 'CALCULATED') {
		return <img src={publishedAsCalulatedImage} alt="dpTypeIcon" className="dpd-table-icon" />;
	}

	return null;
};
